import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RichTextStyle } from "../RichText";
import { Nav, NavContainer } from "./TabNavigation.styles";
var TabNavigation = function(param) {
    var children = param.children, _textStyle = param.textStyle, textStyle = _textStyle === void 0 ? RichTextStyle.Primary : _textStyle;
    return /*#__PURE__*/ _jsx(NavContainer, {
        children: /*#__PURE__*/ _jsx(Nav, {
            "aria-label": "Tabs",
            role: "tablist",
            textStyle: textStyle,
            children: children
        })
    });
};
export { TabNavigation };
